const paths = {
  home: '/',
  auth: '/login',
  oazisSuppliersMap: '/oazis-suppliers-map',
  trips: '/reports/trips',
  tripsMap: '/reports/eco-events',
  events: '/reports/events',
  garage: '/garage',
  carFleet: '/settings/car-fleet',
  client: '/settings/client',
  geoFences: '/geo-fences',
  reports: '/reports/page',

  tasks: {
      root: '/task-planner',
      new: '/task-planner/new-task',
      all: '/task-planner/all-tasks',
      schedules: '/task-planner/schedules',
  },

  admin: {
      onBoard: '/settings/on-board',
      decoder: '/teltonika-decoder'
  },

  regularUserAccess: [],
  adminWall: [],

  guestModePageNames: [
      'ViewOnlyTask'
  ]
};

paths.regularUserAccess = [
    paths.home,
    paths.trips,
    paths.tripsMap,
    paths.events,
    paths.garage,
    paths.carFleet,
    paths.client,
    paths.geoFences,
    paths.reports,
    paths.tasks.root,
    paths.tasks.new,
    paths.tasks.all,
    paths.tasks.schedules
];

paths.adminWall = [
    paths.admin.decoder,
    paths.admin.onBoard,
];

export default paths;
